import "./DownloadAyeSearch.css";

const PUBLIC_BASE = import.meta.env.BASE_URL;

function getOS(): string {
  const platform = window.navigator.userAgent.toLowerCase();
  if (platform.includes("win")) return "Windows";
  if (platform.includes("mac") && !/iphone|ipad|ipod/.test(platform)) return "macOS";
  if (/android/.test(platform)) return "Android";
  if (/iphone|ipad|ipod/.test(platform)) return "iOS";
  if (platform.includes("linux")) return "Linux";
  return "your device";
}

function getDownloadUrl(os: string): string {
  if (os === "Windows") return "/downloads/?platform=windows";
  if (os === "macOS") return "/downloads/?platform=macos";
  if (os === "Android") return "/downloads/?platform=android";
  return "";
}

function startDownload(os: string): void {
  const downloadUrl = getDownloadUrl(os);

  if (!downloadUrl) {
    if (os === "iOS") {
      window.alert("AyeSearch for iOS is currently under development.");
      return;
    }
    window.alert(`AyeSearch is not currently available for ${os}.`);
    return;
  }

  window.location.assign(downloadUrl);
}

export function renderDownloadAyeSearch(): void {
  const app = document.getElementById("app");
  if (!app) return;

  const os = getOS();
  document.title = "Download AyeSearch Browser - AyeSearch";

  app.innerHTML = `
    <div class="download-page">
      <section class="hero">
        <h1>AyeSearch Browser</h1>
        <p class="tagline">Fast. Private. AI-Powered.</p>

        <div class="hero-image-row">
          <img
            src="${PUBLIC_BASE}us/aysearch-browser.png"
            class="side-preview"
            alt="AyeSearch Browser"
          />

          <button
            class="download-btn"
            id="ayesearch-browser-download-btn"
            type="button"
          >
            Download for ${os}
          </button>

          <img
            src="${PUBLIC_BASE}us/aysearch-incognito.png"
            class="side-preview"
            alt="AyeSearch Incognito"
          />
        </div>

        <p class="small-note">Free • Secure • Updated automatically</p>
      </section>

      <section class="feature-split">
        <img
          src="${PUBLIC_BASE}us/aysearch-browser.png"
          class="split-image"
          alt="AyeSearch Preview"
        />

        <div class="split-text">
          <h2>Extend your search experience</h2>
          <p>
            Using our focused future-seeing system approach,
            AyeSearch enhances how you browse, discover, and
            interact with the web.
          </p>
        </div>
      </section>

      <section class="scroll-sections">
        <div class="info-card gradient-card">
          <h2>Secure Browser</h2>
          <p>
            Browse on Windows × Android
            <br />
            iOS Under Development
          </p>
        </div>

        <div class="info-card gradient-card">
          <h2>Stay safe while you browse</h2>
          <p>Advanced protection built directly into the browser.</p>
        </div>

        <div class="info-card gradient-card">
          <h2>Your Privacy, Under Your Control</h2>
          <p>Easy-to-use settings that put you in charge.</p>
        </div>

        <div class="info-card gradient-card">
          <h2>Secure Your Data</h2>
          <p>AyeSearch protects your information at every step.</p>
        </div>

        <div class="info-card gradient-card">
          <h2>A Browser Built by AyeSearch</h2>
          <p>Designed for speed, privacy, and a modern web experience.</p>
        </div>
      </section>

      <footer class="download-footer">
        <div class="footer-content">
          <div class="footer-section">
            <h4>AyeSearch</h4>
            <p>Building the future of search and browsing.</p>
          </div>

          <div class="footer-section">
            <h4>Company</h4>
            <p><a href="mailto:feedback@amailme.com?subject=AyeSearch%20Feedback">Feedback</a></p>
            <p>Careers</p>
            <p>Contact</p>
          </div>

          <div class="footer-section">
            <h4>Social</h4>
            <p><a href="#">Twitter</a></p>
            <p><a href="#">Instagram</a></p>
            <p><a href="#">YouTube</a></p>
          </div>
        </div>

        <p class="footer-bottom">© 2026 AyeSearch — All Rights Reserved</p>
      </footer>
    </div>
  `;

  const downloadButton = document.getElementById(
    "ayesearch-browser-download-btn",
  ) as HTMLButtonElement | null;

  downloadButton?.addEventListener("click", () => {
    startDownload(os);
  });
}

export default renderDownloadAyeSearch;
